import { render, staticRenderFns } from "./safetyShieldApplySuccess.vue?vue&type=template&id=50229c1d&scoped=true"
import script from "./safetyShieldApplySuccess.vue?vue&type=script&lang=js"
export * from "./safetyShieldApplySuccess.vue?vue&type=script&lang=js"
import style0 from "./safetyShieldApplySuccess.vue?vue&type=style&index=0&id=50229c1d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50229c1d",
  null
  
)

export default component.exports